export { default as CalendarIcon } from "PFIcons/calendar_fixed.svg";
export { default as CheckIcon } from "PFIcons/check.svg";
export { default as ClockIcon } from "PFIcons/clock_solid.svg";
export { default as EditIcon } from "PFIcons/edit.svg";
export { default as RightArrowIcon } from "PFIcons/right_arrow.svg";
export { default as TrashIcon } from "PFIcons/trash.svg";
export { default as AddIcon } from "PFIcons/add.svg";

import Office from "PFIcons/office.svg";
import User from "PFIcons/user.svg";
import React from "react";

export const UserIcon: React.FC<any> = (props) => <User {...props} viewBox={"7 0 10 20"} />;
export const OfficeIcon: React.FC<any> = (props) => <Office {...props} viewBox={"7 0 10 20"} />;
